import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  IProposal,
  IProposalListRequest,
  IProposalCreateRequest,
  IProposalUpdateRequest,
  ProposalState,
} from "@/types/proposal";
import CustomRequest from "../customRequest";

const actions: ActionTree<ProposalState, RootState> = {
  async get({ commit }, proposal_id: number) {
    await CustomRequest.get<IProposal>({
      uri: `/proposal/${proposal_id}`,
      commit,
      target: "single",
    });
  },

  async getList({ commit }) {
    await CustomRequest.get<IPagination<IProposal>>({
      uri: `/proposal`,
      commit,
      target: "pagination",
    });
  },

  async salesGet({ commit }, proposal_id: number) {
    await CustomRequest.get<IProposal>({
      uri: `/sales/proposal/${proposal_id}`,
      commit,
      target: "single",
    });
  },

  async salesGetList({ commit }, params: IProposalListRequest) {
    await CustomRequest.get<IPagination<IProposal>>({
      uri: `/sales/proposal/`,
      params,
      commit,
      target: "pagination",
    });
  },

  async salesUpdate(
    { commit },
    datas: { proposal_id: number; params: IProposalUpdateRequest }
  ) {
    const { error } = await CustomRequest.patch<IProposal>({
      uri: `/sales/proposal/${datas.proposal_id}`,
      params: datas.params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async salesCreate({ commit }, params: IProposalCreateRequest) {
    const { error } = await CustomRequest.post<IProposal>({
      uri: `/sales/proposal`,
      params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async salesDelete({ commit }, proposal_id: number) {
    const { error } = await CustomRequest.delete({
      uri: `/sales/proposal/${proposal_id}`,
      flash: true,
    });

    return !error;
  },
};

export default actions;
